import React, { useState } from 'react'
import { Controller, FormContext, useForm } from 'react-hook-form'
import PropTypes from 'prop-types'
import { Box, TextField } from '@material-ui/core'

import {
  BaseDialog,
  FileUploadInput,
  LoadingFeedback,
  Select,
} from 'components'

import useSnackbar from 'hooks/useSnackbar'

import constants from 'constants/index'
import * as service from 'service'
import schema from './schema'
import theme from 'theme'

const DialogTomticket = ({ open, setOpen }) => {
  const { SOLICITATION_ITEMS, SOLICITATION_OTHERS_ID } = constants.faqs

  const [loading, setLoading] = useState(false)

  const snackbar = useSnackbar()
  const formMethods = useForm({
    validationSchema: schema,
    defaultValues: {
      category: SOLICITATION_OTHERS_ID,
      title: '',
      description: '',
      files: undefined,
    },
  })

  const { control, errors, handleSubmit, reset } = formMethods

  const handleClose = () => setOpen(true)

  const onSubmit = async (data) => {
    try {
      setLoading(true)

      await service.dponet.tomticketIntermediator.createTicket(data)

      snackbar.open({
        message: 'Ticket enviado com sucesso!',
        variant: 'success',
      })
      reset()
      handleClose()
    } catch (error) {
      console.error(error)
      snackbar.open({
        message:
          error?.response?.data?.error?.message ||
          'O sistema de abertura de tickets está indisponível no momento. Você pode entrar em contato através do e-mail atendimento@dponet.com.br',
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <BaseDialog
      open={open}
      setOpen={setOpen}
      title="Solicitar atendimento"
      actionButtonText="Solicitar atendimento"
      closeButtonText="Cancelar"
      formRef="solicitation-form"
      dialogSize="md"
      fullWidth
    >
      <LoadingFeedback open={loading} />
      <FormContext {...formMethods}>
        <Box
          component="form"
          id="solicitation-form"
          display="flex"
          flexDirection="column"
          gridGap={theme.spacing(2)}
          onSubmit={handleSubmit(onSubmit)}
          py={2}
        >
          <Controller
            control={control}
            name="category"
            as={
              <Select
                items={SOLICITATION_ITEMS}
                label="Tipo de atendimento"
                error={!!errors?.category}
                helperText={errors?.category?.message}
              />
            }
          />
          <Controller
            control={control}
            name="title"
            as={
              <TextField
                label="Título"
                error={!!errors?.title}
                helperText={errors?.title?.message}
                fullWidth
              />
            }
          />
          <Controller
            control={control}
            name="description"
            as={
              <TextField
                label="Descrição"
                error={!!errors?.description}
                helperText={errors?.description?.message}
                placeholder="Descreva detalhadamente o motivo do seu contato."
                multiline
                minRows={10}
                maxRows={10}
                fullWidth
              />
            }
          />
          <Controller
            control={control}
            name="files"
            as={
              <FileUploadInput
                controlName="files"
                hasDownloadFile
                controllerBar
                multiple
              />
            }
          />
        </Box>
      </FormContext>
    </BaseDialog>
  )
}

DialogTomticket.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
}

export default DialogTomticket
